import { render, staticRenderFns } from "./CompletionComponent.vue?vue&type=template&id=79b4d693&scoped=true"
import script from "./CompletionComponent.vue?vue&type=script&lang=js"
export * from "./CompletionComponent.vue?vue&type=script&lang=js"
import style0 from "./CompletionComponent.vue?vue&type=style&index=0&id=79b4d693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b4d693",
  null
  
)

export default component.exports